/**
 * @author Ariel
 * @date 2020-09-16
 * @desc 活动管理列表页配置
 */
import React from 'react'
import {component_tool} from '../../../tool';
import moment from "moment";
import HighSet from "@/containers/common/highSet";

let {WizModal} = component_tool;
let componentName = 'activity'

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '活动名称',
    name: 'name',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '活动时间',
    name: 'activityTime',
    tableItem: {
      render: (text, record) => {
        let {startTime, endTime} = record
        let value = formatterDate(startTime) + ' ~ ' + formatterDate(endTime)
        return <div>{value}</div>
      }
    }
  },
  // {
  //   title: '是否需要报名',
  //   name: 'apply',
  //   tableItem: {},
  //   searchItem: {type: 'select'},
  //   dict: [
  //     {code: 0, codeName: '否'},
  //     {code: 1, codeName: '是'}
  //   ]
  // },
  {
    title: '状态',
    name: 'state',
    tableItem: {},
    searchItem: {type: 'select'},
    dict: [
      {code: 0, codeName: '关闭'},
      {code: 1, codeName: '打开'}
    ]
  },
  {
    title: '活动时间',
    name: 'activityTime',
    searchItem: {
      type: 'date~',
      format: 'YYYY-MM-DD HH:mm',
      showTime: {format: 'HH:mm'},
    }
  },
  {
    title: '参加人数',
    name: 'participateNum',
    tableItem: {}
  },
];

const templateConfig = (e) => {
  let {_btnFun} = e;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.activityTime && value.activityTime.length === 2) {
              value.startTime = moment(value.activityTime[0]).format('YYYY-MM-DD HH:mm:00')
              value.endTime = moment(value.activityTime[1]).format('YYYY-MM-DD HH:mm:59')
            }
            // delete value.activityTime
            console.log('value', value);
            return value
          },
          buttonSort: ['add', 'linkManagement', 'topicManagement', 'noticeManagement', 'exportActivityInfo', 'exportParticipationData'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/interact/activity/activityDetailAdd',
                }
              }
            },
            {
              key: 'linkManagement',
              name: 'WizButton',
              params: {
                children: '环节管理',
                key: '_partBtn',
                type: 'default',
              },
              onClick: (e) => {
                e['type'] = 'part';
                _btnFun && _btnFun(e)
              }
            },
            {
              key: 'topicManagement',
              name: 'WizButton',
              params: {
                children: '话题管理',
                key: '_topicBtn',
                type: 'default',
              },
              onClick: (e) => {
                e['type'] = 'topic';
                _btnFun && _btnFun(e)
              }
            },
            {
              key: 'noticeManagement',
              name: 'WizButton',
              params: {
                children: '活动公告',
                key: '_messageBtn',
                type: 'default',
              },
              onClick: (e) => {
                e['type'] = 'message';
                _btnFun && _btnFun(e)
              }
            },
            {
              key: 'exportActivityInfo',
              custom: true,
              params: {icon: 'export', children: '导出活动信息', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: 'exportParticipationData',
              custom: true,
              params: {icon: 'export', children: '导出参加数据', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "participateExport",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  if (rows && rows.length && rows.length == 1) {
                    let id ;
                    rows.forEach(d => {
                      id = d.id
                    })
                    filters = {id:id}
                    return {...filters}
                  } else {
                    WizModal.confirm({
                      title: '请选择一条数据',
                      onOk: () => {},
                      onCancel() {}
                    })
                  }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look', 'openOrClose', 'update', 'advancedSet'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/interact/activity/activityLook"
              }
            }
          },
          {
            key: "openOrClose",
            custom: true,
            params: {children: "打开"},
            textFormat: {
              recordKey: 'state',
              dirt: {'1': '关闭', '0': '打开',}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "打开" : "关闭"
                }该活动吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 0 ? 1 : 0,
                      id: record['id'],
                      // ...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/interact/activity/activityDetailUpd"
              },
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: {children: '高级设置'},
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{record: e.record,bizType: 23}}
                               changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = false
              if (record && record['state'] !== 1) {
                disabled = true
              }
              return {disabled}
            }
          },
        ]
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  participateExport: {
    path: `${componentName}/participateExport`,
    payload: {
      key: `${componentName}@participateExport`,
      apiParams: {}
    }
  },
}

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
